var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.01 11.2549H12.22L11.94 10.9849C12.92 9.84488 13.51 8.36488 13.51 6.75488C13.51 3.16488 10.6 0.254883 7.01001 0.254883C3.42001 0.254883 0.51001 3.16488 0.51001 6.75488C0.51001 10.3449 3.42001 13.2549 7.01001 13.2549C8.62001 13.2549 10.1 12.6649 11.24 11.6849L11.51 11.9649V12.7549L16.51 17.7449L18 16.2549L13.01 11.2549ZM7.01001 11.2549C4.52001 11.2549 2.51001 9.24488 2.51001 6.75488C2.51001 4.26488 4.52001 2.25488 7.01001 2.25488C9.50001 2.25488 11.51 4.26488 11.51 6.75488C11.51 9.24488 9.50001 11.2549 7.01001 11.2549Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3ba27bf00b5f199e48e63f89f3989dfd.svg";
export { ForwardRef as ReactComponent };